<template>
  <div
    class="tabs company-tabs"
    v-if="
      isDisplayJobDescription || isDisplayCompanyCareer || isDisplayCompanyPr
    "
  >
    <v-tabs
      class="elevation-2"
      v-model="tab"
      background-color="transparent"
      color="#E8320D"
    >
      <v-tab
        class="tab-item"
        v-for="(item, index) in getTabTitle"
        :key="index"
        :href="`#tab-${item.value}`"
        ><span v-html="$t(item.title, { split: '<br>' })"></span
      ></v-tab>

      <v-tabs-items v-model="tab">
        <v-tab-item :key="0" value="tab-0" v-if="isDisplayJobDescription">
          <table class="table table-in-tab" v-if="dataJobDescription !== null">
            <tr v-if="dataJobDescription.recruiting_target !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.recruiting-target',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ getRecruitingTargetString }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.recruiting_job_type !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.recruiting-job-type',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ getJobTypeString }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.work_content !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.work-content', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.work_content }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.work_location !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.work-location', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ getWorkLocationString }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.work_location_detail !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.work-location-detail',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.work_location_detail }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.work_hours !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.work-hours', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.work_hours }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.break !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.break', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.break }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.holiday !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.holiday', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.holiday }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.salary !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.salary', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.salary }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.allowance !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.allowance', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.allowance }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.employee_benefit !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.employee-benefit',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.employee_benefit }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.insurance !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t('company-detail.title.job-description.insurance', {
                      split: '/'
                    })
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.insurance }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.required_qualification !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.required-qualification',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.required_qualification }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.recruiting_members !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.recruitment-numbers',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{
                  dataJobDescription.recruitment_numbers +
                  ' ' +
                  $t(computedPerson(dataJobDescription.recruitment_numbers), {
                    split: '/'
                  })
                }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.recruitment_history_text !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.recruitment-history-text',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{ dataJobDescription.recruitment_history_text }}
              </td>
            </tr>
            <!--
            <tr
              v-if="dataJobDescription.recruitment_history_vietnamese !== null"
            >
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.recruitment-history-vietnamese',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{
                  dataJobDescription.recruitment_history_vietnamese +
                    ' ' +
                    $t(
                      computedPerson(
                        dataJobDescription.recruitment_history_vietnamese
                      ),
                      { split: '/' }
                    )
                }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.recruitment_history_hust !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.recruitment-history-hust',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{
                  dataJobDescription.recruitment_history_hust +
                    ' ' +
                    $t(
                      computedPerson(
                        dataJobDescription.recruitment_history_hust
                      ),
                      { split: '/' }
                    )
                }}
              </td>
            </tr>

            <tr v-if="dataJobDescription.recruitment_history_other !== null">
              <td class="td-left">
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.job-description.recruitment-history-other',
                      { split: '/' }
                    )
                  }}:</label
                >
              </td>
              <td class="td-right">
                {{
                  dataJobDescription.recruitment_history_other +
                    ' ' +
                    $t(
                      computedPerson(
                        dataJobDescription.recruitment_history_other
                      ),
                      { split: '/' }
                    )
                }}
              </td>
            </tr> -->
          </table>

          <v-card-text v-else>
            {{
              $t('company-detail.data-not-update', {
                split: '/'
              })
            }}
          </v-card-text>
        </v-tab-item>
        <v-tab-item :key="1" value="tab-1" v-if="isDisplayCompanyCareer">
          <v-card flat>
            <table
              class="table-career-vision"
              v-if="dataCompanyCareerFromDetail !== null"
            >
              <thead>
                <td>
                  {{
                    $t('company-detail.title.company-career.title', {
                      split: '/'
                    })
                  }}
                </td>
                <td>
                  {{
                    $t('company-detail.title.company-career.position', {
                      split: '/'
                    })
                  }}
                </td>
                <td>
                  {{
                    $t('company-detail.title.company-career.required-skill', {
                      split: '/'
                    })
                  }}
                </td>
                <td>
                  {{
                    $t('company-detail.title.company-career.content', {
                      split: '/'
                    })
                  }}
                </td>
              </thead>

              <tbody>
                <tr
                  v-for="(item, key) in dataCompanyCareerFromDetail"
                  :key="key"
                >
                  <td>
                    {{ checkYearTitleOfCareerVision(key) }}
                  </td>
                  <td>{{ item.position }}</td>
                  <td>
                    {{ item.required }}
                  </td>
                  <td>
                    {{ item.content }}
                  </td>
                </tr>
              </tbody>
            </table>

            <v-card-text v-else>{{
              $t('company-detail.data-not-update', {
                split: '/'
              })
            }}</v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :key="2" value="tab-2" v-if="isDisplayCompanyPr">
          <v-card flat>
            <v-card-text v-if="dataCompanyPrFromDetail !== null">
              <div>
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.company-promotion.company-promotion',
                      { split: '/' }
                    )
                  }}:</label
                >
                <p
                  v-html="dataCompanyPrFromDetail.company_promotion"
                  class="pre-para"
                ></p>
              </div>
              <div>
                <label for="" class="title-bold"
                  >{{
                    $t(
                      'company-detail.title.company-promotion.recruiting-process',
                      { split: '/' }
                    )
                  }}:</label
                >
                <p
                  v-html="dataCompanyPrFromDetail.selection_process"
                  class="pre-para"
                ></p>
              </div>
            </v-card-text>
            <v-card-text v-else>
              {{
                $t('company-detail.data-not-update', {
                  split: '/'
                })
              }}
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import { LANG_CODE_JAPANESE, PUBLIC_FLAG } from '@/common/constants';
import { mapGetters } from 'vuex';
export default {
  name: 'TabsOfCompany',
  props: {
    dataJobDescription: {
      type: Object
    },

    dataCompanyCareerFromDetail: {
      type: Object
    },

    dataCompanyPrFromDetail: {
      type: Object
    }
  },
  data() {
    return {
      favoriteStatus: 'like',
      tab: 'tab-0'
    };
  },

  methods: {
    isPublic(displayFlag, displayFrom, displayTo) {
      if (
        displayFlag === PUBLIC_FLAG &&
        this.isDisplayByApplicantTimeStamp(displayFrom, displayTo)
      ) {
        return true;
      }
      return false;
    },

    checkYearTitleOfCareerVision(key) {
      let title = '';
      switch (key) {
        case 'career_1':
          title =
            this.$i18n.locale === LANG_CODE_JAPANESE
              ? '1年後/1 year later'
              : '1 năm tới';
          break;

        case 'career_2':
          title =
            this.$i18n.locale === LANG_CODE_JAPANESE
              ? '3年後/3 year later'
              : '3 năm tới';
          break;
        case 'career_3':
          title =
            this.$i18n.locale === LANG_CODE_JAPANESE
              ? '5年後/5 year later'
              : '5 năm tới';
          break;
        case 'career_4':
          title =
            this.$i18n.locale === LANG_CODE_JAPANESE
              ? '10年後/10 year later'
              : '10 năm tới';
          break;

        default:
          title = '';
          break;
      }

      return title;
    }
  },

  created() {},
  computed: {
    ...mapGetters({
      m_event: 'getEventData'
    }),

    isDisplayJobDescription() {
      if (this.m_event) {
        return this.isPublic(
          this.m_event.job_description_use_flag,
          this.m_event.job_description_publicizing_period_from,
          this.m_event.job_description_publicizing_period_to
        );
      }
      return false;
    },

    isDisplayCompanyCareer() {
      if (this.m_event) {
        return this.isPublic(
          this.m_event.career_use_flag,
          this.m_event.career_publicizing_period_from,
          this.m_event.career_publicizing_period_to
        );
      }
      return false;
    },

    isDisplayCompanyPr() {
      if (this.m_event) {
        return this.isPublic(
          this.m_event.promotion_use_flag,
          this.m_event.promotion_publicizing_period_from,
          this.m_event.promotion_publicizing_period_to
        );
      }
      return false;
    },

    getTabTitle() {
      const tabsTitle = [];

      if (this.m_event) {
        if (
          this.isPublic(
            this.m_event.job_description_use_flag,
            this.m_event.job_description_publicizing_period_from,
            this.m_event.job_description_publicizing_period_to
          )
        ) {
          tabsTitle.push({
            title: 'company-detail.tabs.tab1',
            value: 0
          });
        }
        if (
          this.isPublic(
            this.m_event.career_use_flag,
            this.m_event.career_publicizing_period_from,
            this.m_event.career_publicizing_period_to
          )
        ) {
          tabsTitle.push({
            title: 'company-detail.tabs.tab2',
            value: 1
          });
        }
        if (
          this.isPublic(
            this.m_event.promotion_use_flag,
            this.m_event.promotion_publicizing_period_from,
            this.m_event.promotion_publicizing_period_to
          )
        ) {
          tabsTitle.push({
            title: 'company-detail.tabs.tab3',
            value: 2
          });
        }
      }

      return tabsTitle;
    },

    getWorkLocationString() {
      let stringWorkLocation = '';

      const workLocation = this.m_work_location_company;

      const workLocationId =
        this.dataJobDescription.work_location !== null
          ? JSON.parse(this.dataJobDescription.work_location)
          : null;

      if (workLocationId !== null) {
        workLocation.map((ele) => {
          workLocationId.forEach((item, index) => {
            if (item == ele.id) {
              stringWorkLocation += ele.name_convert;
              stringWorkLocation +=
                index < workLocationId.length - 1 ? ', ' : '';
            }
          });
        });
      }

      return stringWorkLocation;
    },

    getJobTypeString() {
      let stringJobType = '';

      const jobType = this.m_occupation_type_company;

      const recruitingJobType = this.dataJobDescription.recruiting_job_type;

      const jobTypeId =
        this.dataJobDescription.recruiting_job_type !== null
          ? JSON.parse(recruitingJobType)
          : null;

      if (jobTypeId !== null) {
        jobType.map((ele) => {
          jobTypeId.forEach((item, index) => {
            if (item == ele.id) {
              stringJobType += ele.name_convert;
              stringJobType += index < jobTypeId.length - 1 ? ', ' : '';
            }
          });
        });
      }

      return stringJobType;
    },

    getRecruitingTargetString() {
      let stringRecruitingTarget = '';

      if (this.c_recruiting_target !== null) {
        const recruitingTarget = this.c_recruiting_target;

        const recruitingTargetData = this.dataJobDescription.recruiting_target;

        const recruitingTargetId =
          recruitingTargetData !== null
            ? JSON.parse(recruitingTargetData)
            : null;

        if (recruitingTargetId !== null) {
          recruitingTarget.map((ele) => {
            recruitingTargetId.forEach((item, index) => {
              if (item == ele.id) {
                stringRecruitingTarget += ele.name_convert;
                stringRecruitingTarget +=
                  index < recruitingTargetId.length - 1 ? ', ' : '';
              }
            });
          });
        }
      }

      return stringRecruitingTarget;
    }
  }
};
</script>

<style lang="scss" scoped>
.pre-para {
  white-space: pre-line;
}
@media only screen and (max-width: 600px) and (orientation: portrait) {
  .tab-item {
    font-size: 10px;
    padding: 3px;
  }
}
</style>
